var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default function createInjectReducer(createReducer) {
  return function (_ref) {
    var key = _ref.key,
        reducer = _ref.reducer;
    return function (Component) {
      var _class, _temp2;

      return _temp2 = _class = function (_PureComponent) {
        _inherits(WithReducer, _PureComponent);

        function WithReducer() {
          var _ref2;

          var _temp, _this, _ret;

          _classCallCheck(this, WithReducer);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = WithReducer.__proto__ || Object.getPrototypeOf(WithReducer)).call.apply(_ref2, [this].concat(args))), _this), _this.store = _this.context.store, _temp), _possibleConstructorReturn(_this, _ret);
        }

        _createClass(WithReducer, [{
          key: 'componentWillMount',
          value: function componentWillMount() {
            var store = this.store;

            if (store.injectedReducers == null) {
              store.injectedReducers = {};
            }

            if (store.injectedReducers[key] && store.injectedReducers[key] === reducer) {
              return;
            }

            store.injectedReducers[key] = reducer;
            store.replaceReducer(createReducer(store.injectedReducers));
          }
        }, {
          key: 'render',
          value: function render() {
            return React.createElement(Component, this.props);
          }
        }]);

        return WithReducer;
      }(PureComponent), _class.displayName = 'withReducer(' + (Component.displayName || Component.name || 'Component') + ')', _class.contextTypes = {
        store: PropTypes.object.isRequired
      }, _temp2;
    };
  };
}